import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconHouse = ({ color = 'currentColor', size = 'medium', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" color={color} size={size} {...props}>
        <StyledStrokedGroup color={color} strokeLinecap="round" strokeLinejoin="round">
            <StyledPath
                d="M0.972046 8.11396L7.26205 1.81863C7.35522 1.72601 7.46573 1.65265 7.58726 1.60276C7.7088 1.55286 7.83897 1.5274 7.97035 1.52784C8.10172 1.52827 8.23173 1.55459 8.35293 1.60528C8.47413 1.65598 8.58415 1.73006 8.67671 1.82329L14.972 8.11396"
                color="none"
            />
            <StyledPath d="M12.972 6.11539V14.1141H2.97205V6.11206" color="none" />
            <StyledPath
                d="M9.97205 14.114V11.114C9.97205 10.5836 9.76133 10.0749 9.38626 9.6998C9.01119 9.32473 8.50248 9.11401 7.97205 9.11401C7.44161 9.11401 6.9329 9.32473 6.55783 9.6998C6.18276 10.0749 5.97205 10.5836 5.97205 11.114V14.114"
                color="none"
            />
        </StyledStrokedGroup>
    </StyledSvg>
);
